module.exports = __webpack_public_path__ + "static/media/busch-1.518ce75f.jpg";